import Vue from 'vue'

const state = {
  eventsList: [],
  selectedEvent: {}
}

const mutations = {
  SET_EVENTS_LIST(state, events) {
    state.eventsList = events
  },
  SET_SELECTED_EVENT(state, event) {
    state.selectedEvent = event
    localStorage.setItem('selectedEvent', JSON.stringify(event))
  }
}

const actions = {
  setEventsList: ({ commit, dispatch }, userId) => {
    Vue.http
      .post('events', { user: userId })
      .then(response => {
        response.json().then(events => {
          commit('SET_EVENTS_LIST', events)
        })
      })
      .catch(_ => {
        dispatch('setSnackbarColor', 'error')
        dispatch('setSnackbarMessage', 'Erro ao listar eventos')
        dispatch('setSnackbarOpen', true)
      })
  },
  setSelectedEvent: ({ commit }, event) => {
    commit('SET_SELECTED_EVENT', event)
  },
  eraseLocalEventData: ({ commit }) => {
    commit('SET_SELECTED_EVENT', {})
    localStorage.removeItem('selectedEvent')
  },
  loadEventFromLocalStore: ({ commit }) => {
    const event = localStorage.getItem('selectedEvent')
    if (!event) {
      return
    }
    commit('SET_SELECTED_EVENT', JSON.parse(event))
  }
}

const getters = {
  eventsList(state) {
    return state.eventsList
  },
  selectedEvent(state) {
    return state.selectedEvent
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/events.js